<template>
<div class="left-content">
  <div class="allproduct">
    <div class="videoCreation" v-for="(item, index) in videoList" :key="index">
      <video-creation :info="item"></video-creation>
    </div>
  </div>
</div>
</template>

<script>
import VideoCreation from "@/components/activity/VideoCreation";
import pages from "@/components/pages.vue";

export default {
  components: {
    VideoCreation,
    pages
  },

  data() {
    return {
      videoList: [],
      pagerParams: {
        pageSize: 12,
        pageCount: 5,
        currentPage: 1,
        total: 1
      }
    };
  },

  watch: {
    "pagerParams.currentPage": function() {
      this.getData(this.$route.params.id, {
        pageIndex: this.pagerParams.currentPage
      });
    },
    $route: function() {
      let currentID = this.$route.params.id;
      if (currentID == this.detailData.id) return;
      this.getData(this.$route.params.id);
    }
  },

  methods: {
    // $t('global.预留分页接口')
    getData(activityId, { pageIndex = 1, pageSize = 12 } = {}) {
      this.$http
        .get("/api/activity/myVideo", {
          params: {
            activityId
            // pageIndex,
            // pageSize
          }
        })
        .then(data => {
          // mock-data
          // return (this.videoList = [
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   },
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   },
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   },
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   },
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   },
          //   {
          //     avatar: "",
          //     nickName: "大薯条",
          //     thumb: "",
          //     title: "$t('global.视频名称')",
          //     url: "",
          //     userId: 0,
          //     videoId: 0
          //   }
          // ]);

          let d = data.data;
          this.videoList = d.list;

          this.pagerParams.currentPage = d.pageIndex;
          this.pagerParams.total = d.totalPage;
          this.pagerParams.pageSize = d.pageSize;
        })
    }
  },

  created() {
    this.getData(this.$route.params.id);
  }
};
</script>

<style lang="stylus" scoped>
.allproduct {
  display: flex;
  flex-wrap: wrap;
}

.videoCreation {
  width: 3.42rem;
  margin: 0.2rem 0.18rem 0 0;
  background: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #d5d5d5;
  border-radius: 0.08rem;

  &:nth-child(3n) {
    margin-right: 0;
  }
}

.left-content {
  width: 10.8rem;
  margin-top: 0.2rem;
  padding: 0.4rem 0.6rem;
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/match/MyCreation.vue